import React, { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const LineCountry = (props) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, [5000]);
  }, []);

  if (props.data || props.info) {
    if (loading) {
      return (
        <div className="center" style={{ textAlign: "center" }}>
          <Loader type="TailSpin" color="#15b4de" height={300} width={"10%"} />
        </div>
      );
    } else {
      return (
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={props.info ? props.info : props.data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey={props.info ? "name" : "0"} stroke="#ffffff" />
              <YAxis stroke="#ffffff" />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey={props.info ? "bounceRate" : 1}
                name={props.info ? "BounceRate" : "plays"}
                stroke="#8884d8"
                activeDot={{ r: 8 }}
              />
              <Line
                type="monotone"
                dataKey={props.info ? "engagementRate" : 2}
                name={props.info ? "EnangementRate" : "ad_impressions"}
                stroke="#0088FE"
              />
              {props.data && (
                <>
                  <Line
                    type="monotone"
                    dataKey={3}
                    name={"completes"}
                    stroke="#00C49F"
                  />
                  <Line
                    type="monotone"
                    dataKey={4}
                    name={"complete_rate"}
                    stroke="#FFBB28"
                  />
                  <Line
                    type="monotone"
                    dataKey={5}
                    name={"time_watched"}
                    stroke="#FF8042"
                  />
                  <Line
                    type="monotone"
                    dataKey={6}
                    name={"embeds"}
                    stroke="#FF8095"
                  />
                </>
              )}
            </LineChart>
          </ResponsiveContainer>
        </div>
      );
    }
  } else {
    if (loading) {
      return (
        <div className="center" style={{ textAlign: "center" }}>
          <Loader type="TailSpin" color="#15b4de" height={300} width={"10%"} />
        </div>
      );
    } else {
      return (
        <div
          className="text-center"
          style={{ height: 300, display: "grid", placeItems: "center" }}
        >
          <h5 className="text-white">No User Engagements for Last 7 Days</h5>
        </div>
      );
    }
  }
};

export default LineCountry;
